function ninaLPBinder() {

  // New Code (EWT Support).
  var lpSiteId = "";

  if (typeof lpTag !== "undefined") {
      lpSiteId = lpTag.site;
  } else {
      lpSiteId = "Unknown";
  };

  nuanceData.chatData = {
          "skillName": {},
          "engId": {},
          "lpSiteId": lpSiteId
      }
      // End new code (EWT Support).

  // OFFER_IMPRESSION: The LP engagement has been displayed on-page.

lpTag.events.bind("LP_OFFERS", "OFFER_IMPRESSION", function(eventData, eventInfo) {

  switch (eventData.engagementType) {
      case 5:
          // New Code (EWT Support)
          if (eventData.engagementName.substr(0, 3) == "VA|") {

              var arr = eventData.engagementName.split('|')
              var product = arr[1];
              var skillName = arr[2];
              var engId = eventData.engagementId;

              nuanceData.chatData.skillName[product] = skillName;
              nuanceData.chatData.engId[product] = engId;
          }
          // End new code (EWT Support).
          break;
      case 6:
          // Do nothing.
          break;
      default:
          // Do nothing.
  }
});

loadLpTags();

}
// End ninaLPBinder
function loadLpTags() {

  var lpTagFiredEvents = lpTag.events.hasFired("LP_OFFERS", "OFFER_IMPRESSION");

  if ((lpTagFiredEvents.length - 1) >= 0) {
      for (var eventFound = 0, eventCount = (lpTagFiredEvents.length - 1); eventCount >= 0, eventFound < 4; eventCount--) {
          if(!lpTagFiredEvents[eventCount]){return;}
              eventData = lpTagFiredEvents[eventCount].data;

              switch (eventData.engagementType) {

              case 5:

              if (eventData.engagementName.substr(0, 3) == "VA|") {

                  var eventInfoArray = eventData.engagementName.split('|');

                  var product = eventInfoArray[1];

                  if (nuanceData.chatData.engId[product] == null ||

                      nuanceData.chatData.engId[product] === '') {

                      nuanceData.chatData.skillName[product] = eventInfoArray[2];

                      nuanceData.chatData.engId[product] = eventData.engagementId;

                      eventFound++;

                  }

              }

              break;

          }

      }

  }

}

// End loadLpTags


// This function tells LiveEngage that the VA Session is In Progress.
// It is called by the backend NinaScript at the point where a VA conversation is initiated.
function VAInProgress() {

  lpTag.sdes = lpTag.sdes || [];
  lpTag.sdes.push({
      "type": "service", //MANDATORY
      "service": {
          "topic": "VA",
          "status": 1 // In Progress.
      }
  });
}

function fireNewEvent(eventName) {
    var event;
    if (typeof(Event) === 'function') {
        event = new Event(eventName);
    } else {
        event = document.createEvent('Event');
        event.initEvent(eventName, false, false);
    }
    window.dispatchEvent(event);
}

// This function is called by the backend NinaScript at the point where a website visitor is being escalated or channeled to a) a voice or chat agent, or b) a web page or email link.
function VAEscalate(ContactType, EngagementID) {

  // Formulate the Nina transcript.
  var ninaTranscript = document.createElement("DIV");
  ninaTranscript.classList.add('nw_ConversationText');
  ninaTranscript.style.display = 'none';


  var chatId = inqFrame.Inq.CHM.chat.cd.id;
  var iframe = document.getElementById('inqChatStage');
  var iframeInnerDoc = iframe.contentDocument;
  var ndepTranscript = iframeInnerDoc.getElementById("transcript");
  ninaTranscript.innerHTML = "";


  if (ndepTranscript.getElementsByClassName('ss-content')[0].hasChildNodes()){
      ndepChatLines = ndepTranscript.getElementsByClassName('ss-content')[0].childNodes

      for (var i = 0; i < ndepChatLines.length - 1; i++) {

          switch(ndepChatLines[i].tagName){
              case "AGENT-SIMPLE-VIEW":
                  ninaTranscript.innerHTML += "<div class='nw_AgentSaysContainer'><div class='nw_AgentSaysAvatar'></div><div class='nw_AgentSays'>" +  ndepChatLines[i].innerText.replace(/(?:\r\n|\r|\n)/g, '<br>') + "</div></div>"
                  break;
              case "CUSTOMER-SIMPLE-VIEW":
                  ninaTranscript.innerHTML += "<div class='nw_UserSaysContainer'><div class='nw_UserSays'>" + ndepChatLines[i].innerText.replace(/(?:\r\n|\r|\n)/g, '<br>') + "</div></div>"
                  break
              default:
                  // Intentionally blank.
          }

      }
  } else {
      // Problem with the chat transcript.
      ninaTranscript.innerHTML += "<div class='nw_AgentSaysContainer'><div class='nw_AgentSaysAvatar'></div><div class='nw_AgentSays'>Sorry, there was a problem getting the customer's Virtual Assistant conversation.<BR><BR>Please raise this with a Direct Line Group Ops Manager, quoting the following conversation ID:<br>" + chatId + "</div></div>"
  }

  // Notify LiveEngage that the visitor has escalated out to another channel.
  lpTag.sdes = lpTag.sdes || [];
  lpTag.sdes.push({
      "type": "service", //MANDATORY
      "service": {
          "topic": "VA",
          "status": 0 // Completed.
      }
  });

  // Custom handling where required.
  switch (ContactType) {

      case "chat":

          // Transcript & chat ID.
          lpTag.sdes = lpTag.sdes || [];
          lpTag.sdes.push({
              "type": "ctmrinfo", //MANDATORY
              "info": {
                  "socialId": ninaTranscript.innerHTML,
                  "imei": chatId
              }
          });


          // Begin logic of checking if the chat button engagement is present on the page.
          if (EngagementID) { // Check if the engagement ID exists.
              ClickChatButton(EngagementID);
          }
          break;

      default:
          // Do nothing.
  }
}

// This function is used to programmatically click on the LP chat button.
function ClickChatButton(EngagementID) {
  if (lpTag && lpTag.taglets && lpTag.taglets.rendererStub) {
      var clicked = lpTag.taglets.rendererStub.click(EngagementID, { preChatLines: [""] });
  }
}
